/* LTCG free-shipping bar: converts threshold to market currency and refreshes after any AJAX cart change. */
(() => {
  if (customElements.get('ltcg-free-shipping')) return;
  window.ltcgMoney = window.ltcgMoney || ((cents, format) => {
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/); if (!m) return (cents / 100).toFixed(2);
    const fx = (n, d, t, dec) => { const p = (n / 100).toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (p[1] ? dec + p[1] : ''); };
    const v = { amount: fx(cents, 2, ',', '.'), amount_no_decimals: fx(cents, 0, ',', '.'), amount_with_comma_separator: fx(cents, 2, '.', ','), amount_no_decimals_with_comma_separator: fx(cents, 0, '.', ','), amount_with_apostrophe_separator: fx(cents, 2, "'", '.'), amount_with_space_separator: fx(cents, 2, ' ', ',') }[m[1]] || fx(cents, 2, ',', '.');
    return format.replace(m[0], v);
  });
  const rate = () => parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
  const fmt = (cents, el) => {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || el.dataset.shopCurrency;
    const mf = el.dataset.moneyFormat;
    if (mf && cur === el.dataset.shopCurrency && window.ltcgMoney) return window.ltcgMoney(cents, mf);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur, maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  };
  class LtcgFreeShipping extends HTMLElement {
    connectedCallback() { this.render(parseInt(this.dataset.total, 10) || 0); }
    render(total) {
      // Threshold converted to presentment currency, rounded up to whole unit like Shopify does for shipping rates.
      const goal = Math.ceil((parseInt(this.dataset.threshold, 10) * rate()) / 100) * 100;
      const left = Math.max(goal - total, 0);
      const pct = Math.min(100, Math.round((total / goal) * 100));
      const t = this.querySelector('.ltcg-fs__text');
      const key = total === 0 ? 'tEmpty' : left > 0 ? 'tLeft' : 'tDone';
      t.innerHTML = (this.dataset[key] || '').replace('[amount]', fmt(total === 0 ? goal : left, this));
      this.querySelector('.ltcg-fs__fill').style.width = pct + '%';
      const g = this.querySelector('.ltcg-fs__goal'); if (g) g.textContent = fmt(goal, this);
      this.classList.toggle('is-done', left === 0 && total > 0);
    }
  }
  customElements.define('ltcg-free-shipping', LtcgFreeShipping);
  let pending;
  const refresh = () => {
    clearTimeout(pending);
    pending = setTimeout(() => {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((c) => { document.querySelectorAll('ltcg-free-shipping').forEach((el) => { el.dataset.total = c.total_price; el.render(c.total_price); }); document.dispatchEvent(new CustomEvent('ltcg:cart-total', { detail: c })); })
        .catch(() => {});
    }, 150);
  };
  // Horizon dispatches 'cart:update'; also catch other themes/apps and bfcache restores.
  ['cart:update', 'cart:updated', 'cart:refresh', 'cart-section:restored', 'pageshow'].forEach((e) => document.addEventListener(e, refresh));
  // Fallback: observe fetches to cart endpoints (apps, quick-add, upsells).
  const of = window.fetch;
  window.fetch = function (input) {
    const p = of.apply(this, arguments);
    try { const u = typeof input === 'string' ? input : input.url; if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(refresh); } catch (e) {}
    return p;
  };
})();
